module.exports = __webpack_public_path__ + "static/019.thumb-64f72b5a1d4320f5fbdadab976a5b3f4.jpg";